// extracted by mini-css-extract-plugin
module.exports = {"results__blocks":"Results_results__blocks__2GHfZ","results__info":"Results_results__info__2IS1H"};